const koTranslation = {
  // 공통
  app_name: '사주 운세',
  home: '홈',
  login: '로그인',
  back: '뒤로',
  next: '다음',
  payment: '결제하기',
  submit: '제출',
  cancel: '취소',
  required: '필수',
  
  // 메인 페이지
  fortune_categories: '운세 카테고리',
  tarot_categories: '타로 카테고리',
  best_items: '베스트 상품',
  best_items_saju: '사주 베스트',
  best_items_tarot: '타로 베스트',
  all_categories: '모아보기',
  favorites: '찜한 상품',
  history: '이용 내역',
  my_page: '마이 페이지',
  tarot_new: '타로 신규 출시!',
  tarot_desc: '역방향 타로 카드까지 풀어주는 진-짜 타로 등장',
  
  // 카테고리
  cat_reunion: '재회운',
  cat_marriage: '결혼운',
  cat_love: '연애운',
  cat_compatibility: '궁합운',
  cat_newyear: '신년운',
  cat_career: '직업운',
  cat_trial: '사주 체험',
  cat_free: '무료 체험',
  cat_wealth: '재물운',
  cat_tarot: '타로',
  cat_tarot_love: '타로 연애',
  cat_tarot_future: '타로 미래',
  cat_tarot_career: '타로 직업',
  cat_saju: '사주',
  best_items_saju: '사주 베스트',
  best_items_tarot: '타로 베스트',
  
  // 상품 제목
  product_reunion_title: '그 사람과 다시 만날 수 있을까?',
  product_compatibility_title: '그 사람과 연애부터 결혼, 그리고 속궁합은?',
  product_marriage_title: '언제 결혼할 수 있을까?',
  product_love_title: '나의 연애운은 어떨까?',
  product_newyear_title: '새해 운세는 어떨까?',
  product_career_title: '나의 직업운은 어떨까?',
  product_wealth_title: '나의 재물운은 어떨까?',
  product_tarot_love_title: '타로로 보는 나의 연애',
  product_tarot_future_title: '타로로 보는 나의 미래',
  product_tarot_career_title: '타로로 보는 나의 직업',
  
  // 상품 상세 페이지
  product_detail_title: '상품 상세 - 사주 운세',
  original_price: '상품 금액',
  discount_rate: '할인',
  final_price: '최종 결제 금액',
  buy_now: '구매하기',
  product_details: '상품 상세',
  reviews: '리뷰',
  product_includes: '본 상담은 다음과 같은 내용을 포함합니다:',
  product_not_found: '상품을 찾을 수 없습니다',
  all_rights_reserved: '모든 권리 보유',
  
  // 상품 설명
  product_reunion_desc: '당신의 사주를 통해 그 사람과의 재회 가능성을 살펴봅니다. 헤어진 연인, 오래된 친구, 잊지 못하는 인연과의 재회 가능성과 시기를 알려드립니다.',
  product_marriage_desc: '당신의 사주를 통해 결혼 시기와 배우자의 특성을 분석합니다. 언제 결혼할 수 있는지, 배우자의 성격과 특징, 결혼 생활의 모습을 알려드립니다.',
  product_love_desc: '당신의 사주를 통해 연애운과 인연을 분석합니다. 현재 관계의 상태, 새로운 인연이 다가오는 시기, 당신에게 맞는 이상형을 알려드립니다.',
  product_compatibility_desc: '두 사람의 사주를 통해 궁합을 분석합니다. 연애 궁합, 결혼 궁합, 그리고 숨겨진 속궁합까지 모두 알려드립니다.',
  product_newyear_desc: '당신의 사주를 통해 2025년 전체 운세를 분석합니다. 재물운, 건강운, 사업운, 중요한 시기 등을 알려드립니다.',
  product_career_desc: '당신의 사주를 통해 타고난 재능과 적성에 맞는 직업, 커리어 성공 시기, 승진이나 이직에 유리한 시기를 분석해 드립니다.',
  product_wealth_desc: '당신의 사주를 통해 재물운을 분석합니다. 수입이 증가하는 시기, 지출을 조심해야 하는 시기, 투자에 유리한 시기와 분야를 알려드립니다.',
  
  // 사주 입력 페이지
  birth_info_title: '생년월일 정보를 입력해주세요',
  birth_info_desc: '정확한 운세를 위해 생년월일과 시간을 입력해주세요.',
  birth_date: '생년월일',
  birth_year: '년',
  birth_month: '월',
  birth_day: '일',
  birth_time: '태어난 시간',
  unknown_time: '시간 모름',
  partner_info: '파트너 생년월일 정보',
  partner_birth_date: '파트너 생년월일',
  requires_partner_info: '상대방의 생년월일 정보가 필요합니다.',
  
  // 고민 입력 페이지
  concern_title: '현재 기념일',
  concern_desc: '고민이나 질문을 입력해주세요 (선택사항)',
  concern_placeholder: '고민이나 질문을 입력해주세요...',
  char_count: '자',
  
  // 결제 페이지
  payment_title: '결제 안내',
  payment_desc: '19,900원이나 할인 받았어요!',
  product_name: '상품명',
  product_price: '상품 금액',
  coupon: '쿠폰',
  total_payment: '최종 결제 금액',
  max_discount: '최대 할인이 적용되었습니다',
  coupon_change: '쿠폰 변경',
  payment_method: '결제방법',
  card_payment: '카드결제',
  bank_transfer: '계좌이체',
  agree_terms: '결제 서비스 이용 약관, 개인정보 처리 등에 동의합니다',
  proceed_payment: '결제하기',
  
  // 결과 페이지
  result_title: '운세 결과',
  result_desc: '입력하신 정보를 바탕으로 운세 결과를 알려드립니다.',
  
  // 로그인 페이지
  login_with_google: '구글로 로그인',
  login_desc: '로그인하면 운세 결과를 저장하고 맞춤 추천을 받을 수 있습니다.',
  login_to_view_profile: '프로필을 보려면 로그인하세요',
  
  // 마이페이지 및 이용내역
  recent_readings: '최근 이용 내역',
  no_readings_yet: '아직 이용 내역이 없습니다',
  start_reading: '운세 보러가기',
  view_all: '전체보기',
  logout: '로그아웃',
  no_products_found: '상품을 찾을 수 없습니다',
  
  // 검증 메시지
  validate_birth_date: '생년월일을 모두 입력해주세요.',
  validate_birth_time: '시간을 입력하거나 시간모름을 체크해주세요.',
  validate_partner_birth: '상대방의 생년월일을 모두 입력해주세요.'
};

export default koTranslation;
